<!-- 商品信息展示组件 -->
<template>
  <div class="product-info-section">
    <div class="product-info-content">
      <div class="info-title-row">
        <h3 class="info-title">商品信息</h3>
      </div>
      <div class="product-info-grid">
        <div class="info-item">
          <span class="info-label">商品编码：</span>
          <span class="info-value">{{ product.bgmCode || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">商品条码：</span>
          <span class="info-value">{{ product.barcode || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">通用名称：</span>
          <span class="info-value" :title="product.bgmName || '-'">{{ product.bgmName || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">规格：</span>
          <span class="info-value" :title="product.spec || '-'">{{ product.spec || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">生产厂家：</span>
          <span class="info-value" :title="product.manufacturer || '-'">{{ product.manufacturer || '-' }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">批号：</span>
          <span class="info-value" :title="product.batchno || '-'">{{ product.batchno || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">批准文号：</span>
          <span class="info-value" :title="product.bgiAppnumber || '-'">{{ product.bgiAppnumber || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">上市许可持有人：</span>
          <span class="info-value" :title="product.bgiPerholder || '-'">{{ product.bgiPerholder || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">处方类型：</span>
          <span class="info-value" :title="product.bgiPretype || '-'">{{ product.bgiPretype || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">商品类型：</span>
          <span class="info-value" :title="product.bgiType || '-'">{{ product.bgiType || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">货架号：</span>
          <span class="info-value" :title="product.shelfCode || '-'">{{ product.shelfCode || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">库存数量：</span>
          <span class="info-value" :title="product.num || '-'">{{ product.num || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">统一零售价：</span>
          <span class="info-value price-value" :title="product.price || '-'">¥{{ product.price || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">会员价：</span>
          <span class="info-value member-price" :title="product.memberPrice || '-'">¥{{ product.memberPrice || '-' }}</span>
        </div>

        <div class="info-item">
          <span class="info-label">促销价：</span>
          <span v-if="product.spPrice" class="info-value promotion-price" :title="product.spPrice || '-'">¥{{ product.spPrice || '-' }}</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label">促销会员价：</span>
          <span class="info-value member-price" :title="product.spMemberPrice || '-'">¥{{ product.spMemberPrice || '-' }}</span>
        </div> -->

        <!-- 积分倍数信息 -->
        <div class="info-item" v-if="product.pointMultiply">
          <span class="info-label">积分倍数：</span>
          <span class="info-value member-price" :title="product.pointMultiply + '倍积分'">{{ product.pointMultiply }}倍</span>
        </div>
        <div class="info-item">
          <span class="info-label">生产日期：</span>
          <span class="info-value" :title="formatDate(product.prodate)">{{ formatDate(product.prodate) }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">失效日期：</span>
          <span class="info-value" :title="formatDate(product.expidate)">{{ formatDate(product.expidate) }}</span>
        </div>
        <div class="info-item" style="width: 300px;">
          <span class="info-label" v-if="keyMap['KCYCXFA']">可参与的促销方案[{{keyMap['KCYCXFA'].showName}}]：</span>
          <span class="info-value" :title="product.promotionPlan || '-'" style="color: #409EFF;">
            {{ product.promotionPlan || '无可用促销方案' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductInfoDisplay',
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    keyMap: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 格式化日期
    formatDate(date) {
      if (!date) return '-'
      try {
        return new Date(date).toLocaleDateString()
      } catch (error) {
        return '-'
      }
    }
  }
}
</script>

<style scoped>
/* 商品信息展示区样式 */
.product-info-section {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.product-info-content {
  padding: 10px;
}

.info-title-row {
  margin-bottom: 10px;
}

.info-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.product-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 10px;
}

.info-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  padding: 4px 0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  color: #666;
  font-weight: 500;
  white-space: nowrap;
  margin-right: 12px;
  font-size: 14px;
}

.info-value {
  color: #333;
  font-weight: 400;
  display: inline-block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

/* 价格相关样式 */
.price-value {
  color: #e74c3c;
  font-weight: 600;
}

.member-price {
  color: #27ae60;
  font-weight: 600;
}

.promotion-price {
  color: #f39c12;
  font-weight: 600;
}

/* 屏幕适配样式 */
@media screen and (max-width: 1366px) {
  .product-info-section {
    display: none;
  }
}
</style>
